import { catchError, map, Observable, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ContactSummary, UnallocatedUser, ContractorRecommendedResourcesRequest } from '@jms/model';
import { AppointmentResourcesService } from '@jms/ui/ui.appointments';

@Injectable()
export class ContractorAppointmentResourcesService implements AppointmentResourcesService {

    private readonly api = 'https://__tenant__/api/portal/contractor/picker/';
    private readonly http = inject(HttpClient);

    constructor() { }

    public getResources(contractorId: string): Observable<ContactSummary[]> {
        return this.http.get<ContactSummary[]>(`${this.api}contact/${contractorId}`)
            .pipe(
                map(x => [UnallocatedUser, ...x]),
                catchError(error => {
                    return [];
                })
            );
    }

    public getRecommendedResources(request: ContractorRecommendedResourcesRequest): Observable<ContactSummary[]> {
        return this.http.post<ContactSummary[]>(`${this.api}contact/recommended`, request)
            .pipe(
                map(x => [UnallocatedUser, ...x]),
                catchError(error => {
                    return of([UnallocatedUser]);
                })
            );
    }

}